var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"employmentTag",on:{"click":_vm.onClick}},[_c('v-chip',{attrs:{"color":_vm.currentColor,"outline":!_vm.active,"close":_vm.showClose,"small":_vm.small,"text-color":_vm.textColor}},[_vm._v(_vm._s(_vm.tagText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }